import { zExt } from "@redotech/rpc/ext";
import { z } from "zod";

export const CustomReportSchema = z.object({
  _id: zExt.objectId(),
  team: zExt.objectId(),
  name: z.string(),
  queryParams: z.map(z.string(), z.string()),
  createdAt: z.date(),
  updatedAt: z.date(),
  // TODO @JstnMcBrd email settings
});

export type CustomReport = z.infer<typeof CustomReportSchema>;
